import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useProgramTheme from '../../../common/use-program-theme';

import { Button } from '../../../components/ui';
import { useUgcDraft } from '../../../models/ugc-draft/context';

type UGCSidebarProps = {
  onSubmit: () => void;
};

const UGCDraftSidebar = ({ onSubmit }: UGCSidebarProps) => {
  const { t } = useTranslation();
  const { isPersisting, isValid } = useUgcDraft();
  const { themeColor } = useProgramTheme();

  const handleSubmit = () => {
    if (isPersisting) return;
    onSubmit();
  };

  const isButtonDisabled = useMemo(() => {
    return !isValid || isPersisting;
  }, [isPersisting, isValid]);

  return (
    <div className="content-submission-actions">
      <div className="content-submission-publish">
        <Button
          style={{ backgroundColor: themeColor }}
          type="submit"
          className="content-submission-publish__submit"
          disabled={isButtonDisabled}
          loading={isPersisting}
          onClick={handleSubmit}
          aria-label={t('ugc_draft.save_post')}
        >
          {t('ugc_draft.save_post')}
        </Button>
      </div>
    </div>
  );
};

export default UGCDraftSidebar;
